import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const PromptDemo = () => {
    const { t } = useTranslation();
    const [view, setView] = useState('protected');
    const [isSimulated, setIsSimulated] = useState(false); // Novo estado para controlar a simulação
    const [key, setKey] = useState(0);

    const vulnerableText = t('demo_response_vulnerable_content');
    const protectedText = t('demo_response_protected_content');

    const handleSimulate = () => {
        setIsSimulated(true);
        setKey(prevKey => prevKey + 1); // Força reinício da animação ao simular
    };
    
    // Reinicia a animação de digitação sempre que a visão muda (APÓS a simulação inicial)
    useEffect(() => {
        if (isSimulated) {
            setKey(prevKey => prevKey + 1);
        }
    }, [view, isSimulated]);

    return (
        <section id="demo" className="py-20 bg-blueprint-bg">
            <div className="container mx-auto px-6">
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-bold text-white" data-aos="fade-up">{t('demo_main_title')}</h2>
                    <p className="text-lg text-gray-300 mt-4 max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="200">{t('demo_main_subtitle')}</p>
                </div>

                <div className="max-w-3xl mx-auto bg-primary shadow-2xl rounded-lg p-6" data-aos="zoom-in-up">
                    <div className="mb-6">
                        <p className="font-bold text-accent mb-2">{t('demo_user_prompt_title')}</p>
                        <div className="bg-secondary p-4 rounded-lg text-gray-300 italic">
                            "{t('demo_user_prompt_content')}"
                        </div>
                    </div>
                    
                    {/* Botão de Simulação que aparece inicialmente */}
                    {!isSimulated && (
                        <div className="text-center mt-6">
                            <button onClick={handleSimulate} className="bg-accent hover:bg-white text-primary font-bold py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105">
                                {t('demo_button_simulate')}
                            </button>
                        </div>
                    )}
                    
                    {/* Toggle e Resposta aparecem APÓS a simulação */}
                    {isSimulated && (
                        <div data-aos="fade-in">
                            <div className="flex justify-center border border-gray-700 rounded-lg p-1 mb-6 max-w-md mx-auto">
                                <button onClick={() => setView('vulnerable')} className={`w-1/2 py-2 rounded-md transition-colors text-sm font-bold ${view === 'vulnerable' ? 'bg-danger-red text-white' : 'text-gray-400 hover:bg-secondary'}`}>
                                    {t('demo_toggle_vulnerable')}
                                </button>
                                <button onClick={() => setView('protected')} className={`w-1/2 py-2 rounded-md transition-colors text-sm font-bold ${view === 'protected' ? 'bg-accent text-primary' : 'text-gray-400 hover:bg-secondary'}`}>
                                    {t('demo_toggle_protected')}
                                </button>
                            </div>
                            
                            <div>
                                {view === 'vulnerable' ? (
                                    <div>
                                        <p className="font-bold text-danger-red mb-2">{t('demo_response_vulnerable_title')}</p>
                                        <div className="bg-red-900/20 border border-danger-red/30 p-4 rounded-lg text-red-300 font-mono text-sm min-h-[100px]">
                                            <p key={key} className="typing-effect" style={{ '--char-count': vulnerableText.length }}>{vulnerableText}</p>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <p className="font-bold text-accent mb-2">{t('demo_response_protected_title')}</p>
                                        <div className="bg-cyan-900/20 border border-accent/30 p-4 rounded-lg text-green-300 font-mono text-sm min-h-[100px]">
                                            <p key={key} className="typing-effect" style={{ '--char-count': protectedText.length }}>{protectedText}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default PromptDemo;